import { API_ENDPOINT, useJwtToken } from 'helper';
import { useQuery } from 'react-query';

export const fetchSite = async (Site_ID, accessToken) => {
  try {
    const siteResponse = await fetch(`${API_ENDPOINT}/sites/${Site_ID}`, {
      method: 'GET',
      headers: {
        Authorization: accessToken,
        'Content-Type': 'application/json',
      },
    });
    if (!siteResponse.ok) {
      const errorData = await siteResponse.json();
      throw new Error(errorData.message || 'Unknown error occurred');
    }

    const site = await siteResponse.json();

    if (!site) {
      throw new Error('No site data found');
    }

    return site;
  } catch (error) {
    console.log('Error Fetching Site Data: ', error);
    throw error;
  }
};

export const useGetSiteData = (Site_ID) => {
  const accessToken = useJwtToken();
  return useQuery(['site', Site_ID], () => fetchSite(Site_ID, accessToken), {
    enabled: !!Site_ID && !!accessToken, // Only fetch if Site_ID is provided
    staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
    retry: 2, // Retry failed requests up to 2 times
  });
};
